import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/privacy-policy.css';
import Bubble from '../components/Bubble';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  // Estado para detectar si es vista móvil
  const [isMobile, setIsMobile] = useState(false);

  // Detectar el tamaño de pantalla
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Comprobar al cargar
    checkMobile();
    
    // Comprobar al cambiar tamaño de ventana
    window.addEventListener('resize', checkMobile);
    
    // Limpiar evento al desmontar
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="privacy-policy-page">
      <h1 className="privacy-policy-title">{t('privacy.page.title')}</h1>
      
      {/* Espacio adicional entre título y burbujas (solo para desktop) */}
      <div style={{ marginTop: isMobile ? '5px' : '60px' }}></div>
      
      {/* Contenedor principal de burbujas */}
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: isMobile ? '15px' : '25px', 
        padding: isMobile ? '5px' : '15px',
        marginBottom: isMobile ? '20px' : '40px',
        marginTop: isMobile ? '0' : null
      }}>
        {/* Primera fila: Burbujas 1 y 2 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 1: Introducción */}
          <Bubble 
            title="Compromiso con tu Privacidad"
            content="En eDOP Token, nos comprometemos con la transparencia total
            y la protección de tus datos. Como proyecto centrado en la democratización
            del acceso a servicios financieros digitales, entendemos la importancia
            de la confianza."
            translationKey="bubbles.privacy.commitment"
            color="blue"
            position="center"
            size="medium"
          />

          {/* Burbuja 2: Información que recopilamos */}
          <Bubble 
            title="No Recopilamos Información"
            content="Para cumplir con nuestra misión de inclusión financiera, nunca
            solicitamos ni pedimos datos de identificación, evita ser victima
            de phishing y nunca releve tus claves privadas o tus frases
            semillas, nunca eDOP Token te las solicitará, recuérdalo."
            translationKey="bubbles.privacy.nocollection"
            color="green"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Espacio adicional entre filas de burbujas (reducido en móvil) */}
        <div style={{ marginTop: isMobile ? '15px' : '60px' }}></div>
        
        {/* Segunda fila: Burbujas 3 y 4 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 3: Cómo usamos tu información */}
          <Bubble 
            title="Cómo usamos tu información"
            content="No recopilamos datos personales o alguna información.
            Solo usamos tu dirección de wallet para operar, datos técnicos
            para mantener la seguridad de la plataforma y, de forma opcional,
            algunos detalles que mejoran tu experiencia. Todo bajo buenas
            prácticas y sin compartir información con terceros."
            translationKey="bubbles.privacy.usage"
            color="orange"
            position="center"
            size="medium"
          />

          {/* Burbuja 4: Protección de datos */}
          <Bubble 
            title="Seguridad y protección"
            content="Aplicamos las mismas medidas de seguridad que protegen
            nuestros smart contracts: protocolos de OpenZeppelin, multifirma
            en operaciones clave, límites para reducir riesgos y monitoreo
            constante. Todo está alineado con nuestras auditorías, garantizando
            la seguridad de tus datos y activos digitales."
            translationKey="bubbles.privacy.security"
            color="purple"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Espacio adicional entre filas de burbujas */} 
        <div style={{ marginTop: isMobile ? '15px' : '60px' }}></div>
        
        {/* Tercera fila: Burbujas 5 y 6 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
         
        </div>
        
        {/* Espacio adicional entre filas de burbujas */} 
        <div style={{ marginTop: isMobile ? '15px' : '60px' }}></div>
        
        {/* Cuarta fila: Burbuja 7 (contacto) - Centrada */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          width: '100%'
        }}>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
